import { toCamelCaseObj } from '@utils';
import { IBrokerConfig, IBrokerLearnConfig } from '../types/master-data';
import { masterDataEndpoints, masterDataFetcher } from './fetchers';

export async function getBrokerConfig({ brandName }: { brandName: string }) {
  const { data } = await masterDataFetcher.get<IBrokerConfig>(
    masterDataEndpoints.getBrokerConfig(brandName)
  );
  return toCamelCaseObj(data);
}

export async function getBrokerLearnConfig({
  brandName,
  product,
  category,
}: {
  brandName: string;
  product: string;
  category: string;
}) {
  const { data } = await masterDataFetcher.get<IBrokerLearnConfig>(
    masterDataEndpoints.getBrokerConfig(brandName, product, category)
  );
  return data;
}
